// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-sr-stories[data-v-74bb06f1]{flex-grow:1;overflow-y:auto;padding:0 8px;scroll-behavior:smooth;-ms-overflow-style:none;scrollbar-width:none;overflow:-moz-scrollbars-none}.frisbuy-sr-stories[data-v-74bb06f1]::-webkit-scrollbar{display:none;width:0!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
